$(document).ready(function(){

	var $form = $('#news_events_filter', $viewport);

	if ($form.length) {

		// Setup auto-submit on change of inputs
		$('input.custom-control-input, select.custom-select', $form).on('change', function(e){
			$form.submit();
		});

		// Hide the submit button
		$('div.submit', $form).hide();

	}

});




